// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d5fcb973e336fe041c55","655":"f6374f4fd87104a0b9c3"}[chunkId] + ".js";
};